import { render, staticRenderFns } from "./manageAnnouncement.vue?vue&type=template&id=3bf4b108&"
import script from "./manageAnnouncement.vue?vue&type=script&lang=js&"
export * from "./manageAnnouncement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports